/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Settings_Dirs_Toast_Delete_LoadingInputs */

const es_settings_dirs_toast_delete_loading = /** @type {(inputs: Settings_Dirs_Toast_Delete_LoadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminando ${i?.label}…`)
};

const en_settings_dirs_toast_delete_loading = /** @type {(inputs: Settings_Dirs_Toast_Delete_LoadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deleting ${i?.label}…`)
};

/**
* | output |
* | --- |
* | "Deleting {label}…" |
*
* @param {Settings_Dirs_Toast_Delete_LoadingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_toast_delete_loading = /** @type {((inputs: Settings_Dirs_Toast_Delete_LoadingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Toast_Delete_LoadingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_toast_delete_loading(inputs)
	return en_settings_dirs_toast_delete_loading(inputs)
});
export { settings_dirs_toast_delete_loading as "settings.dirs.toast.delete_loading" }